import { render, staticRenderFns } from "./PlanTab1.vue?vue&type=template&id=0ace21c6&scoped=true&lang=pug&"
import script from "./PlanTab1.vue?vue&type=script&lang=js&"
export * from "./PlanTab1.vue?vue&type=script&lang=js&"
import style0 from "./PlanTab1.vue?vue&type=style&index=0&id=0ace21c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ace21c6",
  null
  
)

export default component.exports